/**
 * Public landing (`/`) - client acquisition only.
 * Story: hero → outcomes → surfaces → path → FAQ → close.
 * List prices / plan matrix live only on `/pricing` (not embedded on home).
 * No employee/admin noise. No fake proof.
 */

'use client'

import React, { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { useAuth } from '@/domains/auth'
import { HeroSection } from './HeroSection'
import { BenefitsSection } from './BenefitsSection'
import { DeskSurfacesSection } from './DeskSurfacesSection'
import { TrustSection } from './TrustSection'
import { FaqSection } from './FaqSection'
import { CTASection } from './CTASection'
import { LandingFooter } from './LandingFooter'
import { LandingNavbar } from './LandingNavbar'
import { LandingPageMotion } from './LandingPageMotion'
import { MarketAtmosphere } from './MarketAtmosphere'
import '@/shared/theme/styles/landing.css'

export const LandingPage: React.FC = () => {
  const router = useRouter()
  const { isAuthenticated, user } = useAuth()

  useEffect(() => {
    if (isAuthenticated && user) {
      const userType = typeof window !== 'undefined' ? localStorage.getItem('userType') : null
      const hasClientData = (user as { clientData?: unknown }).clientData
      if (userType === 'client' || hasClientData) {
        router.replace('/client/dashboard')
      } else {
        router.replace('/dashboard')
      }
    }
  }, [isAuthenticated, user, router])

  return (
    <div className="landing-page landing-page-home">
      <a href="#main-content" className="landing-skip-link">
        Skip to main content
      </a>
      <div className="landing-canvas" aria-hidden="true">
        <div className="landing-canvas-orb landing-canvas-orb-a" />
        <div className="landing-canvas-orb landing-canvas-orb-b" />
        <MarketAtmosphere />
      </div>
      <LandingNavbar />
      <main className="landing-main landing-main-home" id="main-content" tabIndex={-1} aria-label="Home">
        <LandingPageMotion />
        <HeroSection />
        <BenefitsSection />
        <DeskSurfacesSection />
        <TrustSection />
        <FaqSection />
        <CTASection />
      </main>
      <LandingFooter />
    </div>
  )
}
